export const theme = {
  colors: {
    text: {
      primary: 'var(--color-text-primary)',
      secondary: 'var(--color-text-secondary)',
      tertiary: 'var(--color-text-tertiary)',
      inverse: 'var(--color-text-inverse)',
    },
    surface: {
      base: 'var(--color-surface-base)',
      muted: 'var(--color-surface-muted)',
      raised: 'var(--color-surface-raised)',
    },
    border: {
      default: 'var(--color-border-default)',
    },
    accent: {
      default: 'var(--color-accent)',
      hover: 'var(--color-accent-hover)',
    }
  },
  fonts: {
    primary: 'var(--font-primary)',
    secondary: 'var(--font-secondary)',
    mono: 'var(--font-mono)',
  },
  space: {
    1: 'var(--space-1)',
    2: 'var(--space-2)',
    3: 'var(--space-3)',
    4: 'var(--space-4)',
    5: 'var(--space-5)',
    6: 'var(--space-6)',
    7: 'var(--space-7)',
    8: 'var(--space-8)',
  },
  radius: {
    xs: 'var(--radius-xs)',
    sm: 'var(--radius-sm)',
    md: 'var(--radius-md)',
    lg: 'var(--radius-lg)',
  },
  motion: {
    instant: 'var(--motion-instant)',
    fast: 'var(--motion-fast)',
    normal: 'var(--motion-normal)',
    slow: 'var(--motion-slow)',
  },
  shadows: {
    1: 'var(--shadow-1)',
    2: 'var(--shadow-2)',
    3: 'var(--shadow-3)',
    4: 'var(--shadow-4)',
  }
};
